module.exports = __webpack_public_path__ + "static/media/tenterraces-logo.16973459.png";